/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCreateLineItemFromTiered extends models.BillingRuleCreateLineItemBase {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCreateLineItemFromTiered");
    }

    getFixupPrototypeFunction() { return BillingRuleCreateLineItemFromTiered.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCreateLineItemFromTiered>): BillingRuleCreateLineItemFromTiered {
        let obj = Object.assign(new BillingRuleCreateLineItemFromTiered(), model);
        BillingRuleCreateLineItemFromTiered.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCreateLineItemFromTiered>): BillingRuleCreateLineItemFromTiered {
        if (!model) return null;
        return BillingRuleCreateLineItemFromTiered.newInstance(<BillingRuleCreateLineItemFromTiered> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCreateLineItemFromTiered) {
        if (!obj) return;

        models.BillingRuleCreateLineItemFromTiered.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCreateLineItemFromTiered): boolean {
        if (models.BillingRuleCreateLineItemBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCreateLineItemFromTiered.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tiers) {
            for (let val of this.tiers) {
                models.CreateLineItemTier.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tiers
     */
    tiers: Array<models.CreateLineItemTier>;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
